import type { PivotLayout, PivotLayoutField, PivotLayoutMeasure } from '@ztechapps/common.contract'
import { PivotZoneEnum } from './PivotZoneEnum'

const ZONE_KEYS = {
  [PivotZoneEnum.Rows]: 'rows',
  [PivotZoneEnum.Columns]: 'columns',
  [PivotZoneEnum.Measures]: 'measures',
  [PivotZoneEnum.Filters]: 'filters',
} as const

/** Reads the items a layout holds in a zone. */
export const getPivotZoneItems = (
  layout: PivotLayout,
  zone: PivotZoneEnum
): (PivotLayoutField | PivotLayoutMeasure)[] => layout[ZONE_KEYS[zone]]

/** Replaces the items a layout holds in a zone. */
export const setPivotZoneItems = (
  layout: PivotLayout,
  zone: PivotZoneEnum,
  items: (PivotLayoutField | PivotLayoutMeasure)[]
): PivotLayout => ({ ...layout, [ZONE_KEYS[zone]]: items })
